// Read CSS custom-property values with a literal fallback for environments
// (tests, SSR) where the document isn't available or tokens aren't loaded.

const FALLBACKS: Record<string, string> = {
  "--accent":     "#818cf8",
  "--fg":         "#e8e8ec",
  "--fg-muted":   "#a1a1aa",
  "--fg-subtle":  "#6b6b76",
  "--grid":       "rgba(255,255,255,.04)",
  "--border":     "#25252d",
  "--bg-card":    "#131318",
  "--rag-green":  "#10b981",
  "--rag-amber":  "#f59e0b",
  "--rag-red":    "#ef4444",
};

export function cssVar(name: string, fallback?: string): string {
  if (typeof document !== "undefined") {
    const v = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
    if (v) return v;
  }
  return fallback ?? FALLBACKS[name] ?? "";
}
